export default ({ $axios }) => {
    $axios.onRequest(config => {
        const xsrfToken = getCookieValue('XSRF-REQUEST-TOKEN')
        if (xsrfToken) {
            config.headers = {
                ...config.headers,
                'X-XSRF-TOKEN': xsrfToken,
            }
        }
    })
}

const getCookieValue = cookieName => {
    const cookies = decodeURIComponent(document.cookie).split('; ')
    const cookie = cookies.find(x => x.startsWith(cookieName + '='))
    return cookie?.substring(cookieName.length + 1)
}
